import qs from 'qs'

export default {
    namespaced: true,
    state: {
        shipping_zones: {},
        shipping_by_zones: {}
    },
    mutations: {
        set_shipping_zones(state, zones) {
            state.shipping_zones = zones;
        },
        set_shipping_by_zones(state, shipping) {
            state.shipping_by_zones = shipping;
        },
    },
    actions: {
        async getShippingZones({commit, state}) {
            await this.axios.get(window.global.ajax, {
                params: {
                    action: 'get_zones_list',
                    headers: {
                        'content-type': 'application/json',
                    }
                }
            }).then((res) => {
                if (res.data && res.status === 200) {
                    commit('set_shipping_zones', res.data)
                }
            }).catch((e) => {
                console.log('error')
            })
        },
        async getShippingByZones({commit, state}, zone_id) {
            await this.axios.get(window.global.ajax, {
                params: {
                    action: 'get_shipping_by_zone',
                    "raw_zone_id": zone_id,
                    headers: {
                        'content-type': 'application/json',
                    }
                }
            }).then((res) => {
                if (res.data && res.status === 200) {
                    commit('set_shipping_by_zones', res.data)
                }
            }).catch((e) => {
                console.log('error')
            })
        }
    },
    getters: {
        get_shipping_zones: (state) => state.shipping_zones,
        get_shipping_by_zones: (state) => state.shipping_by_zones,
    }
};